export const configDefaultMap = new Map([
    ['volume_input1', '20'],
    ['volume_input2', '20'],
    ['volume_input3', '20'],
    ['volume_input4', '20'],
    ['volume_input5', '20'],
    ['volume_input6', '20'],
    ['volume_output1', '20'],
    ['volume_output2', '20'],
    ['volume_output3', '20'],
    ['volume_output4', '20'],
    ['volume_output5', '20'],
    ['volume_output6', '20'],
    ['sip_server', 'notset'],
    ['sip_auth_name', 'notset'],
    ['sip_auth_pass', 'notset'],
    ['sip_auth_realm', 'notset'],
    ['sip_outbound_ext1', 'notset'],
    ['sip_tts_ext1', 'EXT1'],
    ['sip_outbound_ext2', 'notset'],
    ['sip_tts_ext2', 'EXT2'],
    ['sip_autoanswer', '0'],
    ['ethernet_ip_mode', 'dhcp'],
    ['ethernet_ip', 'notset'],
    ['ethernet_gateway', 'notset'],
    ['ethernet_netmask', 'notset'],
    ['ethernet_mac', 'notset'],
    ['ethernet_text_to_speech', '0'],
    ['network_dns1', 'notset'],
    ['network_dns2', 'notset'],
    ['band_1', '0'],
    ['band_2', '0'],
    ['band_3', '0'],
    ['band_4', '0'],
    ['band_5', '0'],
    ['band_preset', '0'],
    ['band_enable', '0'],
    ['machine_name', 'notset'],
    ['location_name', 'notset'],
    ['bluetooth_name', 'notset'],
    ['bluetooth_use_pairing', 'false'],
    ['virtualkeypad_lp', 'PGDWN'],
    ['virtualkeypad_lh', 'PGDWN'],
    ['virtualkeypad_rp', 'PGUP'],
    ['virtualkeypad_rh', 'PGUP'],
    ['virtualkeypad_bp', 'EXT1'],
    ['virtualkeypad_bh', 'EXT2'],
])

export const configLabelMap = new Map([
    ['volume_input1', 'Input 1'],
    ['volume_input2', 'Input 2'],
    ['volume_input3', 'Input 3'],
    ['volume_input4', 'Input 4'],
    ['volume_input5', 'Input 5'],
    ['volume_input6', 'Input 6'],
    ['volume_output1', 'Output 1'],
    ['volume_output2', 'Output 2'],
    ['volume_output3', 'Output 3'],
    ['volume_output4', 'Output 4'],
    ['volume_output5', 'Output 5'],
    ['volume_output6', 'Output 6'],
    ['sip_server', 'SIP Server'],
    ['sip_auth_name', 'User ID'],
    ['sip_auth_pass', 'Auth Password'],
    ['sip_auth_realm', 'Auth Realm'],
    ['sip_outbound_ext1', 'Outbound Ext. 1'],
    ['sip_tts_ext1', 'Text To Speech Ext. 1'],
    ['sip_outbound_ext2', 'Outbound Ext. 2'],
    ['sip_tts_ext2', 'Text To Speech Ext. 2'],
    ['sip_autoanswer', 'Auto Answer'],
    ['ethernet_ip_mode', 'IP Mode'],
    ['ethernet_ip', 'IP Address'],
    ['ethernet_gateway', 'Gateway'],
    ['ethernet_netmask', 'Subnet Mask'],
    ['ethernet_mac', 'MAC Address'],
    ['ethernet_text_to_speech', 'Text To Speech'],
    ['network_dns1', 'DNS 1'],
    ['network_dns2', 'DNS 2'],
    ['band_1', '100Hz'],
    ['band_2', '250Hz'],
    ['band_3', '1kHz'],
    ['band_4', '2.5kHz'],
    ['band_5', '10kHz'],
    ['band_preset', 'Preset'],
    ['band_enable', 'Enable'],
    ['machine_name', 'Machine Name'],
    ['location_name', 'Location Name'],
    ['bluetooth_name', 'Bluetooth Name'],
    ['bluetooth_use_pairing', 'Use Pairing'],
    ['virtualkeypad_lp', 'Left Press'],
    ['virtualkeypad_lh', 'Left Hold'],
    ['virtualkeypad_rp', 'Right Press'],
    ['virtualkeypad_rh', 'Right Hold'],
    ['virtualkeypad_bp', 'Both Press'],
    ['virtualkeypad_bh', 'Both Hold'],
])

export const initialConfig = {
    volume_input: {
        volume_input1: configDefaultMap.get('volume_input1'),
        volume_input2: configDefaultMap.get('volume_input2'),
        volume_input3: configDefaultMap.get('volume_input3'),
        volume_input4: configDefaultMap.get('volume_input4'),
        volume_input5: configDefaultMap.get('volume_input5'),
        volume_input6: configDefaultMap.get('volume_input6'),
    },
    volume_output: {
        volume_output1: configDefaultMap.get('volume_output1'),
        volume_output2: configDefaultMap.get('volume_output2'),
        volume_output3: configDefaultMap.get('volume_output3'),
        volume_output4: configDefaultMap.get('volume_output4'),
        volume_output5: configDefaultMap.get('volume_output5'),
        volume_output6: configDefaultMap.get('volume_output6'),
    },
    network: {
        ethernet_ip_mode: configDefaultMap.get('ethernet_ip_mode'),
        ethernet_ip: configDefaultMap.get('ethernet_ip'),
        ethernet_gateway: configDefaultMap.get('ethernet_gateway'),
        ethernet_netmask: configDefaultMap.get('ethernet_netmask'),
        ethernet_mac: configDefaultMap.get('ethernet_mac'),
        ethernet_text_to_speech: configDefaultMap.get('ethernet_text_to_speech'),
    },
    dns: {
        network_dns1: configDefaultMap.get('network_dns1'),
        network_dns2: configDefaultMap.get('network_dns2'),
    },
    band: {
        band_1: configDefaultMap.get('band_1'),
        band_2: configDefaultMap.get('band_2'),
        band_3: configDefaultMap.get('band_3'),
        band_4: configDefaultMap.get('band_4'),
        band_5: configDefaultMap.get('band_5'),
        band_preset: configDefaultMap.get('band_preset'),
        band_enable: configDefaultMap.get('band_enable'),
    },
    general: {
        machine_name: configDefaultMap.get('machine_name'),
        location_name: configDefaultMap.get('location_name'),
    },
    bluetooth: {
        bluetooth_name: configDefaultMap.get('bluetooth_name'),
        bluetooth_use_pairing: configDefaultMap.get('bluetooth_use_pairing'),
    },
    keypad: {
        virtualkeypad_lp: configDefaultMap.get('virtualkeypad_lp'),
        virtualkeypad_lh: configDefaultMap.get('virtualkeypad_lh'),
        virtualkeypad_rp: configDefaultMap.get('virtualkeypad_rp'),
        virtualkeypad_rh: configDefaultMap.get('virtualkeypad_rh'),
        virtualkeypad_bp: configDefaultMap.get('virtualkeypad_bp'),
        virtualkeypad_bh: configDefaultMap.get('virtualkeypad_bh'),
    },
    sip: {    
        sip_server: configDefaultMap.get('sip_server'),
        sip_auth_name: configDefaultMap.get('sip_auth_name'),
        sip_auth_pass: configDefaultMap.get('sip_auth_pass'),
        sip_auth_realm: configDefaultMap.get('sip_auth_realm'),
        sip_outbound_ext1: configDefaultMap.get('sip_outbound_ext1'),
        sip_tts_ext1: configDefaultMap.get('sip_tts_ext1'),
        sip_outbound_ext2: configDefaultMap.get('sip_outbound_ext2'),
        sip_tts_ext2: configDefaultMap.get('sip_tts_ext2'),
        sip_autoanswer: configDefaultMap.get('sip_autoanswer'),
    }
}